// Consentimento de cookies do Google Analytics (Google Consent Mode v2).
//
// Como funciona:
// - Em public/index.html, antes de qualquer medição, o consentimento começa como "negado"
//   (ou "concedido", se o visitante já aceitou em uma visita anterior).
// - Enquanto o visitante não aceita, o Analytics NÃO grava cookies. O Google só recebe
//   sinais anônimos, sem identificar a pessoa.
// - A escolha do visitante fica guardada no navegador dele (localStorage).
//
// A chave abaixo também aparece em public/index.html. Se mudar aqui, mude lá.

const STORAGE_KEY = 'mondego_cookie_consent'; // valores: 'granted' (aceitou) ou 'denied' (recusou)

// Evento usado pelo link "Preferências de cookies" do rodapé para reabrir o aviso.
export const SETTINGS_EVENT = 'mondego:cookie-settings';

// Devolve 'granted', 'denied' ou null (visitante ainda não escolheu).
export const getStoredConsent = () => {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value === 'granted' || value === 'denied' ? value : null;
  } catch (e) {
    return null;
  }
};

// Apaga os cookies do Analytics (_ga, _ga_XXXX...) deste site.
// Usado quando o visitante recusa ou muda de ideia: o Google não apaga sozinho.
export const clearAnalyticsCookies = () => {
  try {
    const host = window.location.hostname;
    const parts = host.split('.');
    // Ex.: www.mondego.com.br -> www.mondego.com.br, .mondego.com.br e .com.br
    const domains = [undefined, host, `.${host}`];
    for (let i = 1; i < parts.length - 1; i += 1) {
      domains.push(`.${parts.slice(i).join('.')}`);
    }
    const names = document.cookie
      .split(';')
      .map((c) => c.split('=')[0].trim())
      .filter((name) => name === '_ga' || name.startsWith('_ga_'));
    names.forEach((name) => {
      domains.forEach((domain) => {
        const domainPart = domain ? `; domain=${domain}` : '';
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domainPart}`;
      });
    });
  } catch (e) {
    /* ignora */
  }
};

// Guarda a escolha do visitante e avisa o Google Analytics.
export const saveConsent = (choice) => {
  const value = choice === 'granted' ? 'granted' : 'denied';
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch (e) {
    /* navegador sem armazenamento: a escolha vale só até recarregar a página */
  }
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', { analytics_storage: value });
    }
  } catch (e) {
    /* ignora */
  }
  if (value === 'denied') clearAnalyticsCookies();
};

// Reabre o aviso para o visitante mudar a escolha.
export const openCookieSettings = () => {
  try {
    window.dispatchEvent(new Event(SETTINGS_EVENT));
  } catch (e) {
    /* ignora */
  }
};
